import { FormControl } from "./formControl";
import { Textarea } from "@chakra-ui/react";
import { useField } from "formik";
import { FC, forwardRef } from "react";

export const FormTextArea: FC<any> = forwardRef(({ name, label, inputProps, autoFocus, onFocus, ...rest }, ref) => {
  const [ field ] = useField(name);

  return (
    <FormControl name={name} label={label} {...rest}>
      <Textarea
        {...field}
        id={name}
        {...inputProps}
        autoFocus={autoFocus}
        onFocus={onFocus}
        ref={ref}
      />
    </FormControl>
  )
});

FormTextArea.displayName = "FormTextArea";
